module.exports = __webpack_public_path__ + "img/apply-to-selected.83640a15.svg";